import { render, staticRenderFns } from "./blacklist-item.vue?vue&type=template&id=6763cfe2&scoped=true"
import script from "./blacklist-item.vue?vue&type=script&lang=js"
export * from "./blacklist-item.vue?vue&type=script&lang=js"
import style0 from "./blacklist-item.vue?vue&type=style&index=0&id=6763cfe2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763cfe2",
  null
  
)

export default component.exports